<template>
  <div>
    <a href="https://twitter.com/LowcoTV" title="Twitter" target="_blank" rel="noopener" aria-label="external link: twitter">
      <icon name="twitter" class="icon" :scale="iconSize"></icon>
    </a>
    <a href="https://discord.gg/Lowco" title="Discord" target="_blank" rel="noopener" aria-label="external link: discord">
      <icon name="discord" class="icon" :scale="iconSize"></icon>
    </a>
    <a href="https://www.youtube.com/user/Lowco2525" title="Youtube" target="_blank" rel="noopener" aria-label="external link: youtube">
      <icon name="youtube" class="icon" :scale="iconSize"></icon>
    </a>
    <a href="https://www.instagram.com/lowco2525/" title="Instagram" target="_blank" rel="noopener" aria-label="external link: instagram">
      <icon name="instagram" class="icon" :scale="iconSize"></icon>
    </a>
    <a href="https://www.twitch.tv/lowco" title="Twitch" target="_blank" rel="noopener" aria-label="external link: twitch">
      <icon name="twitch" class="icon" :scale="iconSize"></icon>
    </a>
  </div>
</template>

<script>
export default {
  name: 'social-media-icons',
  data () {
    return {
      iconSize: 1.55
    }
  }
}
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../variables.scss';
.icon{
  fill: $font-white;
  vertical-align: bottom;
  margin: 0 $standard-spacing;
  transition: $standard-transition;
}
a{
  display: inline-block;
  &:hover, &:focus {
    transform: scale(1.2);
    .icon{
      fill: $light-purple;
    }
  }
}
@media (max-width: 600px){
  .icon{
    margin: 0 $standard-spacing-half;
  }
}
</style>



// WEBPACK FOOTER //
// SocialMediaIcons.vue?4d856656